import BaseService from './baseService';

export default class SnowflakeService extends BaseService {
    constructor() {
        super('snowflake-infrastructure');
    }

    /**
     * Generates the initial Snowflake db infrastructure for the release.
     * @param {number} releaseGroupId - Release group id
     */
    generateInitialDb = (releaseGroupId: number) => this.httpPostRequest(`generate/${releaseGroupId}`);

    /**
    * Gets snowflake configuration.
    * @returns Snowflake account id
    */
    configuration = () => this.httpGetRequest('configuration');

    /**
    * Creates snowflake dynamic table
    * @param {Object} request - Snowflake table object
    * @param {string} request.name - Snowflake table name
    * @param {string} request.sqlQuery - sql query string
    * @param {string} request.type - Snowflake table type
    * @param {number} request.releaseGroupId - release group id
    * @returns Created dashboard data
    */
    createTable = (request: { name: string; sqlQuery: string; type: string; releaseGroupId: number }) => this.httpPostRequest('', request);

    /**
    * Updates dashboard query
    * @param {Object} request - Update Snowflake Table Request
    * @param {number} request.tableId - table id
    * @param {string} request.name - table name
    * @param {number} request.releaseGroupId - release group id
    * @param {string} request.sqlQuery - sql query
    * @param {string} request.type - snowflake table type
    * @returns void
    */
    updateTable = (request: {
        tableId: number;
        name: string;
        releaseGroupId: number;
        sqlQuery: string;
        type: string;
    }) => this.httpPatchRequest('', request);
}